import React from 'react';
import Link from '../../../../core/components/Link';

type MemberItemProps = {
    name: string;
    onClick: (member: string) => void;
};

const MemberItem = ({ name, onClick }: MemberItemProps): JSX.Element => {
    return (
        <div className="form-field group-member">
            <label>{name}</label>
            <span>
                <Link
                    cssName="remove-member"
                    onClick={() => onClick(name)}
                >
                    <span className="icon-glyph icon-remove"></span>remove
                </Link>
            </span>
        </div>
    );
};

export default MemberItem;
